module.exports = __webpack_public_path__ + "static/media/tomaat-garnaal.8cac0682.jpg";